import { MutationTree } from "vuex";
import { ParametresState, PRAMATRES_STORE as s } from "./type"

export const mutations: MutationTree<ParametresState> = {
    [s.SET_LAST_SYNC](state, newVal: string) {
        state.lastSync = newVal;
    },
    [s.SET_MOBI_VERSION](state, newVal: string) {
        state.mobiVersion = newVal;
    },
    [s.SET_LOCAL_POINTAGE_FALSE](state, newVal: number) {
        state.localPointagesfalse = newVal;
    },
    [s.SET_REMOTE_POINTAGE_FALSE](state, newVal: number) {
        state.remotePointagesfalse = newVal;
    },
    [s.SET_LOCAL_SUPPLEMENTS_FALSE](state, newVal: number) {
        state.localSupplementsfalse = newVal;
    },
    [s.SET_REMOTE_SUPPLEMENTS_FALSE](state, newVal: number) {
        state.remoteSupplementsfalse = newVal;
    },
    [s.SET_LOCAL_POINTAGE_FALSE_OTHERS](state, newVal: number) {
        state.localPointagesfalseOthers = newVal;
    },
    [s.SET_REMOTE_POINTAGE_FALSE_OTHERS](state, newVal: number) {
        state.remotePointagesfalseOthers = newVal;
    },
    [s.SET_REMOTE_POINTAGE_TRUE_OTHERS](state, newVal: number) {
        state.remotePointagesTrueOthers = newVal;
    },
    [s.SET_LOCAL_SUPPLEMENTS_FALSE_OTHERS](state, newVal: number) {
        state.localSupplementsfalseOthers = newVal;
    },
    [s.SET_REMOTE_SUPPLEMENTS_FALSE_OTHERS](state, newVal: number) {
        state.remoteSupplementsfalseOthers = newVal;
    },
    [s.SET_REMOTE_SUPPLEMENTS_TRUE_OTHERS](state, newVal: number) {
        state.remoteSupplementsTrueOthers = newVal;
    },
    [s.SET_UPGRADE](state, newVal: string) {      
        state.upgrade = newVal;
    }
}
